<template>
  <div class="ai-check-container">
    <!-- Header Banner -->
    <div class="ai-header-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <div class="banner-left">
          <div class="ai-icon-pulse">
            <i class="el-icon-user-solid"></i>
          </div>
          <div>
            <h1 class="banner-title">DANH SÁCH HỌC SINH SỬ DỤNG THANH TOÁN</h1>
            <p class="banner-subtitle">Quản lý và cấp quyền thanh toán trực tuyến cho học sinh, giám sát hạn mức cấu hình trường học.</p>
          </div>
        </div>
        <div class="banner-actions flex gap-2">
          <el-dropdown @command="handleCommand" class="modern-dropdown-wrapper">
            <el-button type="warning" class="gradient-btn purple-btn">
              Tác vụ gộp <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" class="modern-dropdown-menu">
              <el-dropdown-item command="enableOnlinePayment" icon="el-icon-circle-check">Bật thanh toán trực tuyến</el-dropdown-item>
              <el-dropdown-item command="disableOnlinePayment" icon="el-icon-circle-close">Tắt thanh toán trực tuyến</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- Quick Stats Grid -->
    <div class="ai-stats-grid">
      <div class="stat-card blue">
        <div class="stat-icon"><i class="el-icon-s-custom"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng học sinh sử dụng</p>
          <h3 class="stat-value">{{ numberStudentOnlinePayment }}</h3>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon"><i class="el-icon-warning-outline"></i></div>
        <div class="stat-info">
          <p class="stat-label">Hạn mức giới hạn (Trường)</p>
          <h3 class="stat-value">{{ totalLimitConfigSchool }}</h3>
        </div>
      </div>
      <div class="stat-card purple">
        <div class="stat-icon"><i class="el-icon-lock"></i></div>
        <div class="stat-info">
          <p class="stat-label">Vượt hạn mức</p>
          <h3 class="stat-value">{{ onlinePaymentLimit ? 'Không cho phép' : 'Cho phép' }}</h3>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="glass-card mb-4">
      <el-form :inline="true" :model="dataSearch" class="modern-filter-form">
        <el-form-item label="Trường học">
          <el-select
            v-model="dataSearch.idSchool"
            filterable
            placeholder="Chọn trường"
            class="modern-select school-select"
            @change="handleChangeSchool"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :value="item.id"
              :label="`${item.id} - ${item.schoolName}`"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Trạng thái học sinh">
          <el-select
            v-model="dataSearch.status"
            placeholder="Trạng thái"
            class="modern-select"
            @change="searchHeaderMethod"
          >
            <el-option
              v-for="item in kidStatusList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Khối học">
          <el-select
            v-model="dataSearch.idGrade"
            clearable
            placeholder="Tất cả khối"
            class="modern-select"
            @change="changeGradeMethod"
          >
            <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Lớp học">
          <el-select
            v-model="dataSearch.idClass"
            filterable
            clearable
            placeholder="Tất cả lớp"
            class="modern-select"
            @change="searchHeaderMethod"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Tìm kiếm nhanh">
          <el-input
            v-model="dataSearch.nameOrPhone"
            clearable
            placeholder="Tên, biệt danh, SĐT..."
            class="modern-input"
            prefix-icon="el-icon-search"
            @keyup.enter.native="searchHeaderMethod"
            @clear="searchHeaderMethod"
          />
        </el-form-item>

        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="searchHeaderMethod">Lọc dữ liệu</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Main Student Table -->
    <div class="glass-card table-container mb-4">
      <div class="table-header-info">
        <h4 class="table-title"><i class="el-icon-user"></i> DANH SÁCH HỌC SINH NHÀ TRƯỜNG</h4>
        <span v-if="multipleSelection.length > 0" class="selection-count">Đang chọn: <strong>{{ multipleSelection.length }}</strong> học sinh</span>
      </div>
      
      <el-table
        ref="multipleTable"
        :data="studentList"
        v-loading="loadingData"
        element-loading-text="Đang tải danh sách học sinh..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.7)"
        class="modern-table"
        border
        highlight-current-row
        @selection-change="handleSelectionChange"
        :max-height="tableMaxHeight"
      >
        <el-table-column type="selection" width="55" align="center" fixed />
        <el-table-column type="index" label="STT" width="55" align="center" fixed />

        <el-table-column label="Mã Học Sinh" width="130" align="center" prop="kidCode" fixed>
          <template slot-scope="{ row }">
            <code class="code-badge">{{ row.kidCode }}</code>
          </template>
        </el-table-column>

        <el-table-column label="Họ và tên" min-width="180" prop="fullName" fixed>
          <template slot-scope="{ row }">
            <span class="student-name">{{ row.fullName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Biệt danh" min-width="120" align="center" prop="nickName">
          <template slot-scope="{ row }">
            <span class="nickname-text">{{ row.nickName || '—' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Lớp học" min-width="130" align="center" prop="maClass.className">
          <template slot-scope="{ row }">
            <span class="class-text">{{ row.maClass ? row.maClass.className : '—' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Giới tính" width="100" align="center" prop="gender">
          <template slot-scope="{ row }">
            <el-tag :type="row.gender === 'Nữ' ? 'danger' : 'primary'" size="medium" effect="plain">{{ row.gender }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="Trạng thái thanh toán" width="220" align="center">
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.enableOnlinePayment"
              active-color="#10b981"
              inactive-color="#cbd5e1"
              :disabled="checkLimitOnlinePayment"
              @change="handleEnableOnlinePayment(row)"
            />
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination Table 1 -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNumber"
          :page-sizes="$pageListDefaultUser || [10, 20, 50, 100]"
          :page-size="maxPageItem"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        >
        </el-pagination>
      </div>
    </div>

    <!-- Section 2: Change History -->
    <div class="glass-card">
      <div class="history-header">
        <div class="history-title-group">
          <h3 class="history-main-title">LỊCH SỬ THAY ĐỔI VƯỢT HẠN MỨC CHO PHÉP</h3>
          <p class="history-subtitle">
            Tổng số học sinh sử dụng lớn nhất thay đổi trong tháng: 
            <strong class="max-value">{{ maxValueChange }} học sinh</strong>
          </p>
        </div>
        
        <div class="history-filter-right">
          <el-date-picker
            v-model="month"
            :clearable="false"
            type="month"
            placeholder="Chọn tháng"
            value-format="M-yyyy"
            format="MM-yyyy"
            class="month-picker"
            @change="searchByPropertiesHistory"
          />
        </div>
      </div>

      <!-- History Table -->
      <el-table
        :data="studentListChange"
        v-loading="loadingDataHistory"
        element-loading-text="Đang tải lịch sử hạn mức..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.7)"
        class="modern-table mt-3"
        border
        highlight-current-row
        :max-height="450"
      >
        <el-table-column type="index" label="STT" width="60" align="center" />

        <el-table-column label="Thời gian ghi nhận thay đổi" min-width="220" align="center">
          <template slot-scope="{ row }">
            <span class="date-time-text">{{ formatDate(row.createdDate) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Số học sinh thay đổi gần nhất" min-width="220" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" class="link-action-btn" @click="handleClickShowStudents(row.id, 'change')">
              {{ row.numberStudentChange }} học sinh
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="Tổng số học sinh đang sử dụng khi thay đổi" min-width="260" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" class="link-action-btn primary" @click="handleClickShowStudents(row.id, 'all')">
              {{ row.sumNumberStudentChangeUser }} học sinh
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination Table 2 -->
      <div class="pagination-wrapper mt-3">
        <el-pagination
          background
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageNumber2"
          :page-sizes="$pageListDefaultUser || [10, 20, 50, 100]"
          :page-size="maxPageItem2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal2"
        >
        </el-pagination>
      </div>
    </div>

    <!-- Student Detail Dialog -->
    <StudentChangeOnlinePaymentDialog
      :isStudentChangeOnlinePaymentDialog="isStudentChangeOnlinePaymentDialog"
      :type="type"
      :idHistory="idHistory"
      :typeUser="typeUser"
      :idSchool="idSchool"
      @closeDialog="closeStudentChangeOnlinePaymentDialog"
    />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission.js";
import { kidStatusList, loginStatusList } from "@/constant/listCommon";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import sePayConnectionService from "@/services/SePayConnectionService";
import StudentChangeOnlinePaymentDialog from "@/views/sepay/dialog/StudentChangeOnlinePaymentDialog.vue";
import SystemConfigService from "@/services/AdminService/SystemConfigService";

export default {
  name: "StudentUserStatisticsAdmin",
  components: { StudentChangeOnlinePaymentDialog },
  data() {
    return {
      loadingData: false,
      loadingDataHistory: false,
      textTable: "",
      pageTotal: 0,
      maxPageItem: 25,
      pageNumber: 1,
      pageTotal2: 0,
      maxPageItem2: 25,
      pageNumber2: 1,
      multipleSelection: [],
      studentList: [],
      dataSearch: {
        loginStatus: "",
        status: "STUDYING",
        idGrade: "",
        idClass: "",
        nameOrPhone: "",
        type: "startDate",
        dateList: [],
        idSchool: ""
      },
      schoolList: [],
      loginStatusList,
      kidStatusList,
      numberStudentOnlinePayment: 0,
      totalLimitConfigSchool: 0,
      onlinePaymentLimit: false,
      studentListChange: [],
      maxValueChange: 0,
      month: this.getCurrentMonth(),
      isStudentChangeOnlinePaymentDialog: false,
      type: "",
      idHistory: 0,
      typeUser: "admin",
      gradeOfSchoolList: [],
      classList: [],
      idSchool: 0
    };
  },

  computed: {
    tableMaxHeight() {
      return this.$tableMaxHeightCardManager || 650;
    },

    checkLimitOnlinePayment() {
      return this.numberStudentOnlinePayment >= this.totalLimitConfigSchool && this.onlinePaymentLimit === true;
    }
  },

  watch: {
    gradeOfSchoolList: {
      immediate: true,
      handler(newVal) {
        if (newVal.length > 0 && this.getAppTypeUserLogin === "plus") {
          this.getIdGrade();
        }
      }
    },
    classList: {
      handler(newVal) {
        if (newVal.length > 0 && this.getAppTypeUserLogin === "teacher") {
          this.getIdClassInTeacher();
        }
      }
    }
  },

  created() {
    this.findAllAppIconForSchool();
  },

  methods: {
    checkPermission,
    getCurrentMonth() {
      const now = new Date();
      const month = now.getMonth() + 1;
      const year = now.getFullYear();
      return `${month}-${year}`;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    async handleEnableOnlinePayment(row) {
      const sum = this.numberStudentOnlinePayment + 1;

      const confirm = async (message, options = {}) => {
        try {
          await this.$confirm(message, "Thông báo!", {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
            ...options
          });
          return true;
        } catch (e) {
          return false;
        }
      };

      const updateAndNotify = async () => {
        try {
          await sePayConnectionService.updateStatusOnlinePaymentAdmin(
            row.id,
            row.enableOnlinePayment,
            this.dataSearch.idSchool
          );
          NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!");
          await this.searchByProperties();
          await this.searchByPropertiesHistory();
        } catch (error) {
          console.error(error);
          NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!");
        }
      };

      if (row.enableOnlinePayment === true) {
        if (this.onlinePaymentLimit === true) {
          if (sum > this.totalLimitConfigSchool) {
            NotifyMessage.leftCornerNotificationError("Vượt giới hạn cho phép");
            row.enableOnlinePayment = false;
            return;
          }

          const confirmed = await confirm("Bạn có chắc chắn bật thanh toán trực tuyến cho học sinh đã chọn?");
          if (confirmed) {
            await updateAndNotify();
          } else {
            row.enableOnlinePayment = false;
          }
        } else {
          if (sum > this.totalLimitConfigSchool) {
            const confirmed = await confirm(
              "⚠️ <strong>Cảnh báo vượt quá hạn mức!</strong><br/>Bạn có chắc chắn bật thanh toán trực tuyến cho học sinh đã chọn?",
              {
                dangerouslyUseHTMLString: true,
                type: "warning"
              }
            );
            if (confirmed) {
              await updateAndNotify();
            } else {
              row.enableOnlinePayment = false;
            }
          } else {
            const confirmed = await confirm("Bạn có chắc chắn bật thanh toán trực tuyến cho học sinh đã chọn?");
            if (confirmed) {
              await updateAndNotify();
            } else {
              row.enableOnlinePayment = false;
            }
          }
        }
      } else {
        const confirmed = await confirm("Bạn có chắc chắn tắt thanh toán trực tuyến cho học sinh đã chọn?");
        if (confirmed) {
          try {
            await sePayConnectionService.updateStatusOnlinePaymentAdmin(
              row.id,
              row.enableOnlinePayment,
              this.dataSearch.idSchool
            );
            NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!");
            await this.searchByProperties();
          } catch (error) {
            console.error(error);
            NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!");
          }
        } else {
          row.enableOnlinePayment = true;
        }
      }
    },

    handleSizeChange(maxPageItem) {
      this.maxPageItem = maxPageItem;
      this.searchByProperties();
    },

    handleCurrentChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.searchByProperties();
    },

    handleSizeChange2(maxPageItem) {
      this.maxPageItem2 = maxPageItem;
      this.searchByPropertiesHistory();
    },

    handleCurrentChange2(pageNumber) {
      this.pageNumber2 = pageNumber;
      this.searchByPropertiesHistory();
    },

    searchHeaderMethod() {
      this.pageNumber = 1;
      this.searchByProperties();
    },

    async searchByProperties() {
      this.loadingData = true;
      await this.getInfoStudentOnlinePayment();
      try {
        const resp = await sePayConnectionService.searchKidsByAdmin(
          this.pageNumber,
          this.maxPageItem,
          this.dataSearch.loginStatus,
          this.dataSearch.status,
          this.dataSearch.idGrade,
          this.dataSearch.idClass,
          this.dataSearch.nameOrPhone,
          this.dataSearch.type,
          this.dataSearch.dateList,
          this.dataSearch.idSchool
        );
        this.studentList = resp.data.data.dataList || [];
        this.pageTotal = resp.data.data.total || 0;
      } catch (err) {
        this.pageTotal = 0;
        this.studentList = [];
        console.error(err);
      } finally {
        this.loadingData = false;
      }
    },

    async searchByPropertiesHistory() {
      this.loadingDataHistory = true;
      const [monthStr, yearStr] = this.month.split("-");
      const monthNumber = parseInt(monthStr);
      const yearNumber = parseInt(yearStr);
      try {
        const resp = await sePayConnectionService.findHistoryChangeStudentOnlinePaymentAdmin(
          monthNumber,
          yearNumber,
          this.maxPageItem2,
          this.pageNumber2,
          this.dataSearch.idSchool
        );
        this.studentListChange = resp.data.data.historyChangeStudentOnlinePaymentResponseList || [];
        this.pageTotal2 = resp.data.data.total || 0;
        this.maxValueChange = resp.data.data.maxValueChange || 0;
      } catch (err) {
        this.pageTotal2 = 0;
        this.studentListChange = [];
        console.error(err);
      } finally {
        this.loadingDataHistory = false;
      }
    },

    handleCommand(command) {
      if (command === "enableOnlinePayment") {
        this.activeOnlinePayment(true);
      } else if (command === "disableOnlinePayment") {
        this.activeOnlinePayment(false);
      }
    },

    async activeOnlinePayment(value) {
      const idList = this.multipleSelection.map((x) => x.id);

      if (idList.length === 0) {
        NotifyMessage.leftCornerNotificationError("Không có học sinh nào được chọn");
        return;
      }

      const sum = this.multipleSelection.length + this.numberStudentOnlinePayment;

      const confirm = async (message, options = {}) => {
        try {
          await this.$confirm(message, "Thông báo!", {
            distinguishCancelAndClose: true,
            confirmButtonText: "Có",
            closeOnClickModal: false,
            cancelButtonText: "Không",
            ...options
          });
          return true;
        } catch (e) {
          return false;
        }
      };

      if (value === true) {
        if (this.onlinePaymentLimit === true) {
          if (sum > this.totalLimitConfigSchool) {
            NotifyMessage.leftCornerNotificationError("Vượt giới hạn cho phép");
            return;
          }

          const confirmed = await confirm("Bạn có chắc chắn bật thanh toán trực tuyến cho danh sách học sinh đã chọn?");
          if (confirmed) {
            await this.handleChangeStatusOnlinePayment(idList, value);
          }
        } else {
          if (sum > this.totalLimitConfigSchool) {
            const confirmed = await confirm(
              "⚠️ <strong>Cảnh báo vượt quá hạn mức!</strong><br/>Bạn có chắc chắn bật thanh toán trực tuyến cho danh sách học sinh đã chọn?",
              {
                dangerouslyUseHTMLString: true,
                type: "warning"
              }
            );
            if (confirmed) {
              await this.handleChangeStatusOnlinePayment(idList, value);
            }
          } else {
            const confirmed = await confirm("Bạn có chắc chắn bật thanh toán trực tuyến cho danh sách học sinh đã chọn?");
            if (confirmed) {
              await this.handleChangeStatusOnlinePayment(idList, value);
            }
          }
        }
      } else {
        const confirmed = await confirm("Bạn có chắc chắn tắt thanh toán trực tuyến cho danh sách học sinh đã chọn?");
        if (confirmed) {
          await this.handleChangeStatusOnlinePayment(idList, value);
        }
      }
    },

    async handleChangeStatusOnlinePayment(idList, value) {
      const data = {
        idKidList: idList,
        enableOnlinePayment: value,
        idSchool: this.dataSearch.idSchool
      };

      try {
        await sePayConnectionService.updateStatusOnlinePaymentByListAdmin(data);
        NotifyMessage.leftCornerNotificationSuccess("Thay đổi thành công!");
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError("Thay đổi thất bại!");
      }

      await this.searchByProperties();
      await this.searchByPropertiesHistory();
    },

    async getInfoStudentOnlinePayment() {
      try {
        const resp = await sePayConnectionService.getInfoStudentOnlinePaymentAmin(this.dataSearch.idSchool);
        this.numberStudentOnlinePayment = resp.data.data.numberStudentOnlinePayment || 0;
        this.totalLimitConfigSchool = resp.data.data.totalLimitConfigSchool || 0;
        this.onlinePaymentLimit = resp.data.data.onlinePaymentLimit || false;
      } catch (err) {
        console.error(err);
      }
    },

    changeGradeMethod() {
      this.dataSearch.idClass = "";
      this.searchHeaderMethod();
    },

    getIdGrade() {
      if (this.gradeOfSchoolList.length > 0) {
        this.dataSearch.idGrade = this.gradeOfSchoolList[0].id;
      }
      this.searchByProperties();
    },

    getIdClassInTeacher() {
      const checkedClass = this.classList.filter((x) => x.checked);
      if (checkedClass.length > 0) {
        this.dataSearch.idClass = checkedClass[0].id;
      }
      this.searchByProperties();
    },

    formatDate(iso) {
      if (!iso) return "—";
      const d = new Date(iso);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())} - ${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    },

    handleClickShowStudents(id, type) {
      this.idHistory = id;
      this.type = type;
      this.isStudentChangeOnlinePaymentDialog = true;
    },

    closeStudentChangeOnlinePaymentDialog() {
      this.isStudentChangeOnlinePaymentDialog = false;
      this.searchByPropertiesHistory();
    },

    async findAllAppIconForSchool() {
      try {
        const resp = await SystemConfigService.findSchoolConfig("", this.dataSearch.idSchool, true);
        this.schoolList = resp.data.data || [];
        if (this.schoolList.length > 0) {
          this.dataSearch.idSchool = this.schoolList[0].id;
          await this.handleChangeSchool();
        }
      } catch (err) {
        console.error(err);
      }
    },

    async handleChangeSchool() {
      try {
        const resp = await sePayConnectionService.searchGradeInSchool(this.dataSearch.idSchool);
        this.gradeOfSchoolList = resp.data.data || [];
        if (this.gradeOfSchoolList.length > 0) {
          this.dataSearch.idGrade = this.gradeOfSchoolList[0].id;
        }
        this.idSchool = Number(this.dataSearch.idSchool);
      } catch (err) {
        console.error(err);
      }
      await this.handleChangeClass();
      await this.searchByPropertiesHistory();
    },

    async handleChangeClass() {
      try {
        const resp = await sePayConnectionService.searchClassInGrade(this.dataSearch.idSchool, this.dataSearch.idGrade);
        this.classList = resp.data.data || [];
        this.searchHeaderMethod();
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-container {
  padding: 16px;
  background-color: #f4f6fa;
  min-height: calc(100vh - 120px);
}

/* Header Banner Styling */
.ai-header-banner {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 32px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.15);

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  }

  .banner-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    width: 100%;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .ai-icon-pulse {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    animation: iconPulse 3s infinite ease-in-out;

    i {
      font-size: 32px;
      color: #fff;
    }
  }

  .banner-title {
    color: #fff;
    font-size: 22px;
    margin: 0 0 6px 0;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .banner-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    margin: 0;
  }

  .gradient-btn {
    border: none;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
    }

    &.purple-btn {
      background: linear-gradient(90deg, #8b5cf6 0%, #6d28d9 100%);
      box-shadow: 0 4px 10px rgba(139, 92, 246, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(139, 92, 246, 0.4); }
    }
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  }
}

/* Stats Cards Grid */
.ai-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .stat-info {
    flex: 1;
  }

  .stat-label {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: #64748b;
  }

  .stat-value {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
  }

  /* Colors */
  &.blue {
    border-left: 4px solid #3b82f6;
    .stat-icon { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
  }
  &.green {
    border-left: 4px solid #10b981;
    .stat-icon { background: rgba(16, 185, 129, 0.1); color: #10b981; }
  }
  &.purple {
    border-left: 4px solid #8b5cf6;
    .stat-icon { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }
  }
}

/* Glassmorphic Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.table-container {
  background: #fff;
  padding: 12px;
}

/* Filter Forms */
.modern-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  .modern-select {
    width: 175px;

    &.school-select {
      width: 250px;
    }
  }

  .modern-input {
    width: 220px;
  }
}

/* Table styling */
.table-header-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  padding: 4px 6px;

  .table-title {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #3b82f6;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .selection-count {
    font-size: 13px;
    color: #64748b;
  }
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 8px 0;
  }
}

.code-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  color: #475569;
  border: 1px solid #cbd5e1;
}

.student-name {
  font-weight: 700;
  color: #1e293b;
  font-size: 14px;
}

.nickname-text {
  font-weight: 600;
  color: #64748b;
}

.class-text {
  font-weight: 600;
  color: #2563eb;
}

/* Limit history section */
.history-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 12px;
  margin-bottom: 12px;

  .history-main-title {
    margin: 0 0 4px 0;
    font-size: 15px;
    font-weight: 700;
    color: #1e3c72;
    text-transform: uppercase;
  }

  .history-subtitle {
    margin: 0;
    font-size: 13px;
    color: #64748b;

    .max-value {
      color: #b91c1c;
      font-size: 14px;
    }
  }

  .month-picker {
    width: 160px;
  }
}

.date-time-text {
  font-family: Consolas, Monaco, monospace;
  font-weight: 600;
  color: #475569;
}

.link-action-btn {
  font-weight: 700;
  font-size: 14px;
  color: #ef4444;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }

  &.primary {
    color: #3b82f6;
  }
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.mb-4 { margin-bottom: 16px; }
.mt-3 { margin-top: 12px; }
.flex { display: flex; }
.gap-2 { gap: 8px; }
.justify-center { justify-content: center; }
</style>
